var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnouncementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7227 10.9375V9.0625H23.0433V10.9375H18.7227ZM20.1629 20L16.6776 17.1875L17.7145 15.6875L21.1998 18.5L20.1629 20ZM17.8009 4.28125L16.764 2.78125L20.1629 0L21.1998 1.5L17.8009 4.28125ZM3.74453 18.75V13.75H1.72825C1.24818 13.75 0.84012 13.5677 0.504072 13.2031C0.168024 12.8385 0 12.3958 0 11.875V8.125C0 7.60417 0.168024 7.16146 0.504072 6.79688C0.84012 6.43229 1.24818 6.25 1.72825 6.25H6.91299L12.6738 2.5V17.5L6.91299 13.75H5.47278V18.75H3.74453ZM13.826 14.1875V5.8125C14.3444 6.3125 14.7621 6.92188 15.079 7.64063C15.3958 8.35938 15.5542 9.14583 15.5542 10C15.5542 10.8542 15.3958 11.6406 15.079 12.3594C14.7621 13.0781 14.3444 13.6875 13.826 14.1875ZM1.72825 8.125V11.875H7.37385L10.9456 14.1875V5.8125L7.37385 8.125H1.72825Z",
    fill: "#073044"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementIcon);
export default __webpack_public_path__ + "static/media/announcement-icon.7afc5655169857ff2e1d4bafb178cfa3.svg";
export { ForwardRef as ReactComponent };